import customDataReducer from "@crescentParts/Store/Data/CustomDataReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

(reducers as any).cpeState = customDataReducer;

type Reducers = {
    cpeState: typeof customDataReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;